import Config from "../Config";
import { authHeader, handleResponse } from "../helpers/requestHelpers";

const config = new Config();

export function getUsageLogs(loadOptions, resellerId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(resellerId)
    };

    let query = new URLSearchParams(loadOptions).toString();

    return function (dispatch) {
        return fetch(config.backendHost + "/usageLogs/getUsageLogs?" + query, requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}
